export const EVENT_STATES = {
  soldOutWaitlistEnabled: 'soldOutWaitlistEnabled',
  soldOutWaitlistNotEnabled: 'soldOutWaitlistNotEnabled',
  fanReminderWaitlistEnabled: 'fanReminderWaitlistEnabled',
  fanReminderWaitlistEnabledWithLockedTickets:
    'fanReminderWaitlistEnabledWithLockedTickets',
  salesEnded: 'salesEnded',
  unavailableAllHidden: 'unavailableAllHidden',
  unavailableOnlyAtDoor: 'unavailableOnlyAtDoor',
  unavailableGeofenced: 'unavailableGeofenced',
  semiAvailableAllLocked: 'semiAvailableAllLocked',
  semiAvailableNotStarted: 'semiAvailableNotStarted',
  salesEndedEventOver: 'salesEndedEventOver',
  availableStandard: 'availableStandard',
  noData: 'noData',
  noIdea: 'noIdea',
}
